import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'


export default StyleSheet.create({
  inputText: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
  }),
  inputContainer: {
    marginHorizontal: 0,
    minHeight: 55,
    marginVertical: 10,
    height: 'auto'
  },
  headerStyle: {
    marginHorizontal: 0
  },
  titleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h4,
    marginTop: 35,
    marginBottom: 5
  }),
  buttonStyle: {
    marginTop: 60,
    marginBottom: 10
  }
})
